import React, { Component } from 'react';
import $ from 'jquery';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, systemConfig, getZkShopName, getTaoteShopName } from '../../utils/http';
import { Switch, Message } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import ShowModal from '../../components/showModal/index.jsx';
import '../../assets/css/common.less';
import './index.less';

class autoAfterSaleSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectShopId: "",//当前登录的店铺id，非阿里的
            selectPlatformType: "",//当前登录的店铺类型
            orderBackflowSwitch: false,
            autoAfterSwitch: false,
            isShowModalWareHouseOpen: false,
            returnShippingFeeSetType: 0
        };
    }

    componentDidMount() {
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
            that.loadData();
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);
                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });
                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData();
            }, 500);
        }
    }

    changeNav = (name) => {
        this.props.history.replace(name)
    }

    loadData = () => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.setState({
            selectShopId: shopInfo.loginShopId,
            selectPlatformType: shopInfo.loginShopPlatformType,
        }, () => {
            that.loadSetInfo();
        })
    }

    loadSetInfo = () => {
        this.setState({ isLoading: true });
        var that = this;

        requests({
            url: "/ListingConfig/SystemSetinfoConfigGet",
            data: { ShopId: this.state.selectShopId },
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var config = res.Data.OrderAutoOperateConfig;
                    var orderBackflowSwitch = false;
                    if (config != null && config.IsAutoRefund == "1")
                        orderBackflowSwitch = true;

                    var autoAfterSwitch = false;
                    if (config != null && config.IsAutoWareHouseRetrunRefund == 1) {
                        autoAfterSwitch = true;
                    }

                    var returnShippingFeeSetType = 0;
                    if (config != null && config.WareHouseRetrunRefundType != null && config.WareHouseRetrunRefundType != undefined) {
                        returnShippingFeeSetType = config.WareHouseRetrunRefundType;
                    }

                    that.setState({ orderBackflowSwitch: orderBackflowSwitch, autoAfterSwitch: autoAfterSwitch, returnShippingFeeSetType: returnShippingFeeSetType });
                } else {
                    Message({
                        showClose: true,
                        message: "初始化信息错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });
    }

    orderBackflowSwitchOnChange = (checked) => {
        this.setState({ orderBackflowSwitch: checked }, () => {
            this.saveSetInfo();
        });
    }

    saveSetInfo = () => {
        if (this.state.isShowWarn == true) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

        this.setState({ isLoading: true });

        var data = {
            ShopId: this.state.selectShopId,
            PlatformType: this.state.selectPlatformType,
            IsAutoRefund: this.state.orderBackflowSwitch == false ? "0" : "1",
            SaveType: "autoAfterSaleSet",
        };

        var that = this;
        requests({
            url: "/ListingConfig/SystemSetinfoConfigValue",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    Message({
                        showClose: true,
                        message: "设置成功",
                        type: 'success'
                    });
                } else {
                    that.setState({ orderBackflowSwitch: !that.state.orderBackflowSwitch });
                    Message({
                        showClose: true,
                        message: "初始化信息错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });
    }

    // 官方仓自动售后-设置开关
    autoWareHouseRetrunRefundOnChange = (checked) => {
        this.saveWareHouseRetrunAutoAfter(checked);
    }

    saveWareHouseRetrunAutoAfter = (checked) => {
        if (this.state.isShowWarn == true) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

        this.setState({ isLoading: true });

        var data = {
            ShopId: this.state.selectShopId,
            PlatformType: this.state.selectPlatformType,
            IsAutoWareHouseRetrunRefund: checked ? 1 : 0,
            SaveType: "autoWareHouseRetrunRefund",
            WareHouseRetrunRefundType: this.state.returnShippingFeeSetType,
        };

        var that = this;
        requests({
            url: "/ListingConfig/SystemSetinfoConfigValue",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    that.setState({ autoAfterSwitch: checked });
                    Message({
                        showClose: true,
                        message: "设置成功",
                        type: 'success'
                    });
                } else {
                    if (res.ErrorCode == "NOT_OPEN_ALIBABA_WAREHOUSE") {
                        that.setState({ isShowModalWareHouseOpen: true });
                    } else {
                        Message({
                            showClose: true,
                            message: "初始化信息错误：" + res.Message,
                            type: 'error'
                        });
                    }
                }
            }
        });
    }

    GotoOpenWareHouse() {
        window.open("https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/home");
    }

    //关闭模板弹窗  --公共
    closeModal = (modalName) => {
        this.setState({
            [modalName]: false
        })
    }

    onChangeFeeSetType() {
        let feeSetType = $("input[name=returnShippingFeeSet]:checked").val();
        this.setState({ returnShippingFeeSetType: feeSetType - 0 }, () => {
            this.saveWareHouseRetrunRefundType();
        });
    }

    saveWareHouseRetrunRefundType = () => {
        if (this.state.isShowWarn == true) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

        this.setState({ isLoading: true });

        var data = {
            ShopId: this.state.selectShopId,
            PlatformType: this.state.selectPlatformType,
            WareHouseRetrunRefundType: this.state.returnShippingFeeSetType,
            SaveType: "autoWareHouseRetrunRefund",
            IsAutoWareHouseRetrunRefund: 1,
        };

        var that = this;
        requests({
            url: "/ListingConfig/SystemSetinfoConfigValue",
            data: data,
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    Message({
                        showClose: true,
                        message: "设置成功",
                        type: 'success'
                    });
                } else {
                    Message({
                        showClose: true,
                        message: "初始化信息错误：" + res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });
    }

    gotoHistory = (pathname) => {
        this.props.history.push({ pathname: pathname });
    }

    render() {

        const { isShowWarn, orderBackflowSwitch, selectPlatformType, autoAfterSwitch, returnShippingFeeSetType, isShowModalWareHouseOpen, isLoading } = this.state;

        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/autoAfterSaleSet"} />
                    </div>
                    <div className="wrap-right">
                        <ShowWarn
                            isShow={isShowWarn}
                            targetUrl={this.changeNav}
                            from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' : null}
                            alibabaNickName={getZkShopName()}
                            taoteNickName={getTaoteShopName()}
                        />

                        <div className='zk-maiwrap distributionSet mywrap'>
                            <div className="distributionSet-title mainColor">
                                <span>一分钟了解自动申请退款</span>
                                <span style={{ marginLeft: '10px', color: "#fead33" }}>已支持1688，暂不支持淘特订单</span>
                            </div>
                            <div className="distributionSet-two">
                                <div>
                                    <span style={{ marginRight: "5px" }}>店铺订单已退款-采购单批量关闭/申请退款</span>
                                    <Switch value={orderBackflowSwitch} onText="开" offText="关" onChange={this.orderBackflowSwitchOnChange} />
                                </div>
                            </div>
                            <div className="distributionSet-two">
                                <div style={{ color: "#888" }}>针对店铺订单已退款完成，系统支持自动申请关闭厂家发货前的采购单（包括未支付采购单和已支付的采购单）</div>
                                <div style={{ color: "#FF511C" }}>注意：目前还不支持已发货后订单的退款退货或换货厂家，若售后订单为退款退货，还需要手动去1688申请协商</div>
                            </div>

                            {/* 官方仓自动售后 */}
                            {selectPlatformType == "TouTiao" ?
                                <div className="Warehouse_AutoAfterSales-box">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ marginRight: "12px", fontSize: '14px', color: "#333" }}>官方仓自动售后</span>
                                        <Switch onText="" offText="" value={autoAfterSwitch} onChange={this.autoWareHouseRetrunRefundOnChange} />
                                    </div>
                                    <div className='warehouse_AutoAfterSales-tip'>
                                        已开通1688官方仓退货服务才可开启该配置，如果未开通请先前往开通。
                                        <a href="https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/home" target="_blank">{'立即前往>'}</a>
                                    </div>
                                    <div className='warehouse_AutoAfterSales-tip'>
                                        开启后请选择官方仓售后单运费处理方式，选好后请前往<span onClick={() => this.gotoHistory("/officialReturnWarehouse")} >官方退货仓</span>
                                        同步官方仓地址至店铺，订单货源只有一个供应商并由铺货代发发货，买家申请整单退货退款，且售后地址为官方仓时，卖家在抖音后台同意售后申请，
                                        系统会自动向供应商发起售后申请，在买家上传快递单号后自动创建官方仓退货订单
                                    </div>

                                    {autoAfterSwitch ?
                                        <div>
                                            <div style={{ marginTop: "46px", fontSize: '14px', color: "#333" }}>1688退运费处理方式</div>
                                            <div className='wareHouseRetrunRefundType-box'>
                                                <label style={{ paddingTop: '14px' }}>
                                                    <input type="radio" name='returnShippingFeeSet' value={0} checked={returnShippingFeeSetType == 0} onChange={() => this.onChangeFeeSetType()} />
                                                    <span>平台订单整单退货，采购单申请售后时，申请全额退运费；平台订单部分退货，采购订单申请售后时，不申请退运费</span>
                                                </label>
                                                <div>
                                                    <label>
                                                        <input type="radio" name='returnShippingFeeSet' value={1} checked={returnShippingFeeSetType == 1} onChange={() => this.onChangeFeeSetType()} />
                                                        <span>所有采购单售后均申请全额退运费</span>
                                                    </label>
                                                    <span style={{ color: '#999' }}>（若平台订单部分退货，则有概率出现供应商拒绝申请）</span>
                                                </div>
                                                <label style={{ paddingTop: '14px' }}>
                                                    <input type="radio" name='returnShippingFeeSet' value={2} checked={returnShippingFeeSetType == 2} onChange={() => this.onChangeFeeSetType()} />
                                                    <span>所有采购单售后均不申请退运费</span>
                                                </label>
                                            </div>
                                        </div> : null
                                    }
                                </div> : null
                            }

                            <ShowModal showModal={isShowModalWareHouseOpen} hideBtn={true} titleName={'提示'} showTitleClose={true} >
                                <div className="showModalWrap-box-commonContent">
                                    <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                                        <span>该分销账号暂未开通1688官方仓退货，请先前往开通</span>
                                    </div>
                                </div>
                                <div className="showModalWrap-box-commonfooter">
                                    <span className="showModalWrap-box-footer-btn" onClick={() => this.GotoOpenWareHouse()}>前往开通</span>
                                    <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalWareHouseOpen")}>取消</span>
                                </div>
                            </ShowModal>
                        </div>
                    </div>
                </main>
                <MyLoading isLoading={isLoading} isStopOperate={true} fullCenter={true} />
                <NewUserGuide></NewUserGuide>
            </div>
        )
    }
}

export default autoAfterSaleSet;


// WEBPACK FOOTER //
// ./src/pages/autoAfterSaleSet/autoAfterSaleSet.jsx